import React from "react";
import { Box } from "@mui/material";
import { columns } from "./columns";

import MuiTable from "../../../board/components/BoardTable/MuiTable";
import Loader from "../../../../../components/Loader";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { useMissingStatusReport } from "../../hooks/useMissingStatusReport";

export const StatusTable = React.memo(() => {
  const isMobile = useResponsive("down", "md");
  const { rows, isLoading } = useMissingStatusReport();

  return (
    <>
      {isLoading ? (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      ) : (
        rows && (
          <Box p={isMobile && 1} mt={isMobile && 1}>
            <MuiTable
              initialRows={rows}
              columns={columns(isMobile)}
              defaultSort={"username"}
              headerBgColor={"#F2F4F6"}
              scrollHeight={"calc(96vh - 170px)"}
            />
          </Box>
        )
      )}
    </>
  );
});
